import AccessProfileModel from "api/models/AccessProfileModel";
import { addDoc, deleteDoc, getDoc } from "firebase/firestore";
import {
  fromDocumentData,
  getCollectionRef,
  getDocumentRef,
  onCollectionSnapshot,
  toDocumentData,
  updateDocument,
} from "./FirebaseRepository";

class AccessProfileRepository {
  private path = (companyUid: string) => `company/${companyUid}/roles`;

  public async addAccessProfileToDataBase(
    companyUid: string,
    data: AccessProfileModel
  ): Promise<string> {
    const collection = getCollectionRef(this.path(companyUid), converter);
    const doc = await addDoc(collection, data);
    return doc.id;
  }

  public deleteAccessProfileFromDataBase(companyUid: string, uid: string) {
    const doc = getDocumentRef(this.path(companyUid), uid);
    return deleteDoc(doc);
  }

  public async getAccessProfileFromDatabaseByUid(
    companyUid: string,
    profileUid: string
  ): Promise<AccessProfileModel | undefined> {
    const path = this.path(companyUid);
    const doc = getDocumentRef(path, profileUid);
    const snapshot = await getDoc(doc);
    return snapshot.exists()
      ? converter.fromFirestore(snapshot, undefined)
      : undefined;
  }

  public updateAccessProfileOnDataBase(
    companyUid: string,
    uid: string,
    updatedData: Partial<AccessProfileModel>
  ): Promise<void> {
    const doc = getDocumentRef(this.path(companyUid), uid);
    const data = converter.toFirestore(updatedData);
    return updateDocument(doc, data);
  }

  public addAccessProfilesCollectionSnapshot(
    companyUid: string,
    onCreate: (data?: AccessProfileModel[]) => void,
    onChange: (data?: AccessProfileModel[]) => void,
    onRemove: (data?: AccessProfileModel[]) => void
  ) {
    const path = this.path(companyUid);
    const collection = getCollectionRef(path, converter);
    return onCollectionSnapshot<AccessProfileModel>(
      collection,
      (data) => onCreate(data),
      (data) => onChange(data),
      (data) => onRemove(data),
      (error) => console.error("AccessProfileSnapshot", error)
    );
  }
}

// Firestore data converter
const converter = {
  toFirestore: (profile: Partial<AccessProfileModel>) => {
    const data =
      profile instanceof AccessProfileModel ? profile.toSave() : profile;
    return toDocumentData(data);
  },
  fromFirestore: (snapshot, options) => {
    let data = snapshot.data(options);
    data = fromDocumentData(data);
    return AccessProfileModel.create(snapshot.id, data);
  },
};

export default new AccessProfileRepository();
